import { motion } from "framer-motion";
import { IMAGES } from "../../lib/constants";

const items = [
  { src: IMAGES.campusBuilding, title: "Modern Campus", subtitle: "Architecturally crafted for learning", span: "lg:col-span-2 lg:row-span-2" },
  { src: IMAGES.campusLab, title: "Smart Labs", subtitle: "Industry-grade equipment", span: "lg:col-span-2" },
  { src: IMAGES.campusStudents, title: "Vibrant Student Life", subtitle: "Clubs, fests & community", span: "" },
  { src: IMAGES.campusGraduation, title: "Graduation Day", subtitle: "Where journeys begin", span: "" },
  { src: IMAGES.campusLibrary, title: "Resource Library", subtitle: "Books, e-journals & study pods", span: "" },
  { src: IMAGES.campusSports, title: "Sports & Wellness", subtitle: "Indoor + outdoor facilities", span: "" },
  { src: IMAGES.campusCultural, title: "Cultural Events", subtitle: "Annual fests & competitions", span: "lg:col-span-2" },
  { src: IMAGES.campusWorkshop, title: "Workshops & Hackathons", subtitle: "Hands-on learning", span: "" },
];

const CampusLife = () => {
  return (
    <section id="campus" className="py-20 md:py-28 bg-megha-bg" data-testid="section-campus">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-6 items-end mb-12">
          <div>
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-megha-accent">Campus Life</div>
            <h2 className="mt-2 font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight text-megha-text">
              Where learning meets life.
            </h2>
          </div>
          <p className="text-slate-600 text-base md:text-lg">
            Smart classrooms, modern labs, sports grounds, cultural events and student clubs — MIETW is a campus that
            balances academic rigor with everything that makes engineering college memorable.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4" data-testid="campus-gallery">
          {items.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.05, duration: 0.5 }}
              className={`group relative rounded-2xl overflow-hidden shadow-lg shadow-blue-900/5 ${it.span}`}
            >
              <img
                src={it.src}
                alt={it.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-megha-primary/90 via-megha-primary/20 to-transparent opacity-90 group-hover:opacity-100 transition-opacity" />
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5 text-white">
                <div className="font-heading font-extrabold text-lg md:text-xl">{it.title}</div>
                <div className="text-xs md:text-sm text-blue-50/90 mt-0.5">{it.subtitle}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CampusLife;
